(function () {
    'use strict';

    angular.module('processModule')
        .controller('areasTreeview', areasTreeviewController);

    areasTreeviewController.$inject = ['$scope', '$timeout', '$http', '$state', 'pubSub', 'configService'];

    function areasTreeviewController($scope, $timeout, $http, $state, pubSub, configService) {
        var vm = this;
        var currentRecursiveIndex = 0;
        var indexOfChildren = 0;
        var killProcessAreaRouteChanged = null;
        vm.isExpanded = false;

        vm.initialize = initialize;
        vm.items = [];
        vm.parentList = [];
        vm.allAreas = [];
        vm.selectNodeInAreaTree = selectNodeInAreaTree;
        vm.handleExpandArea = handleExpandArea;
        vm.wrapText = configService.getBool(HandbookConfiguration.WrapTextInNavigationTree);
        vm.InterconnectedProcess = configService.getBool(HandbookConfiguration.InterconnectedProcess);
        vm.processClassificationTypes = E.processClassificationTypes;
        vm.processRelatedItemType = E.processRelatedItemType;
        
        function initialize() {
            getAllAccessibleAreas();
            buildTree();
            killProcessAreaRouteChanged = pubSub.subscribe(broadcastType.processAreaRouteChanged, processAreaRouteChanged);
        }

        $scope.$on('$destroy', function () {
            killProcessAreaRouteChanged();
        });

        function buildTree() {
            $http.get(handbookRequests.GetProcessAreasRequest, {
                params: {
                    areaId: null,
                    showProcessesInTree: true,
                    isOnlyApproved: true,
                    isInterconnectedProcess: vm.InterconnectedProcess
                }
            }).success(function (data) {
                if (data) {
                    $scope.processAreasList = data.areas;
                    decorateNodes($scope.processAreasList, null);
                    if (window.location.href.indexOf('/area/detail') > -1) {
                        let areaId = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
                        if (areaId && areaId != '') {
                            getParentAreasRecursive(areaId, true);
                        }
                    }
                    else if (window.location.href.indexOf('/process-detail/viewsendtohearing') > -1) {
                        const url = '/process-detail/viewsendtohearing/';
                        let substringFrom = window.location.href.lastIndexOf(url) + url.length;
                        let substringTo = window.location.href.lastIndexOf('/');
                        let processNumber = window.location.href.slice(substringFrom, substringTo);

                        if (processNumber && processNumber != '') {
                            getParentAreasRecursive(processNumber, false);
                        }
                    }
                    else if (window.location.href.indexOf('/process-detail') > -1) {
                        let processNumber = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
                        if (processNumber && processNumber != '') {
                            getParentAreasRecursive(processNumber, false);
                        }
                    }
                    else if (window.location.href.indexOf('/process-interconnected') > -1) {
                        let processNumber = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
                        if (processNumber && processNumber != '') {
                            getParentAreasProcessInterconnectedRecursive(processNumber, false);
                        }
                    }
                }
            });
        }

        $scope.options = {
            dropped: function (event) { },
            beforeDrop: function (event) { }
        };

        function getAllAccessibleAreas() {
            return $http.get(handbookRequests.GetAllAccessibleAreasRequest, {
                params: {
                    changeLocationMode: 0 //changeLocationMode.ReadArea
                }
            }).success(function (data) {
                if (data) {
                    vm.allAreas = data;
                }

            },
                function () {
                    vm.allAreas = [];
                });
        }

        function processAreaRouteChanged(target) {
            if (target.areaId == null && target.processNumber == null) {
                $('.selected').removeClass('selected');
            }
            if (target.processNumber && target.processClassification == E.processClassificationTypes.Processes) {
                getParentAreasRecursive(target.processNumber, false);
            } else if (target.processNumber && target.processClassification == E.processClassificationTypes.ProcessInterconnected) {
                getParentAreasProcessInterconnectedRecursive(target.processNumber, false);
            } else {
                let isExistAreaId = vm.allAreas.some(function (item) { return item.id == target.areaId; });
                if (isExistAreaId) {
                    getParentAreasRecursive(target.areaId, true);
                }
            }
        }

        function handleExpandArea(expanded, itemId, selectedNode) {
            if (expanded == true && selectedNode.$modelValue.type == 0 && (selectedNode.$modelValue.childCount > 0)) {
                var siblings = selectedNode.$parentNodeScope == null ? selectedNode.processAreasList : selectedNode.$parentNodeScope.$modelValue.items;
                var modelValue = selectedNode.$modelValue;
                if (modelValue.isLoaded) {
                    afterExpanded(itemId, 0);
                    return;
                } else {
                    modelValue.isLoaded = true;
                }

                $http.get(handbookRequests.GetProcessAreasRequest, {
                    params: {
                        areaId: itemId,
                        showProcessesInTree: true,
                        isOnlyApproved: true,
                        isInterconnectedProcess: vm.InterconnectedProcess
                    }
                })
                    .success(function (data, status, headers, config) {
                        if (data) {
                            decorateNodes(data.areas, data.processes);
                            var length = siblings.length;
                            for (var i = 0; i < length; i++) {
                                if (siblings[i].id == itemId) {
                                    vm.selectedNode = siblings[i];
                                    if (siblings[i].items == null) {
                                        siblings[i].items = [];
                                    }
                                    siblings[i].items = siblings[i].items.concat(data.areas);
                                    siblings[i].items = siblings[i].items.concat(data.processes);
                                    afterExpanded(itemId, 0);
                                    break;
                                }
                            }
                        }
                    },
                        function (data, status, headers, config) {
                            //modelValue.items = [];
                        });
            }
        }
       

        function selectNodeInAreaTree(node, item, collapsed, $event) {
            if ((item.type == 0 || !item.type) && !item.processClassification) {
                $state.go('process-area-detail', { areaId: item.id });
            }
            else if (item.type == E.processRelatedItemType.Process && item.processClassification == 1) {
                $state.go('process-detail', { processNumber: item.processNumber });
            }
            else if (item.type == E.processRelatedItemType.ProcessInterconnected && item.processClassification == 2) {
                $state.go('process-interconnected', { processNumber: item.processNumber });
            }
            let isSelectedFolder = $(event.target).hasClass('selected');
            if ((isSelectedFolder || collapsed) && HandbookConfiguration.ToggleFolderUponClick.toUpperCase() == "TRUE") {
                vm.isExpanded = true;
                item.expanded = !item.expanded;
                handleExpandArea(collapsed, item.id, node);
                $scope.toggle(node);
            }
            setHighlight($event);
        }

        $scope.toggle = function (scope) {
            scope.toggle();
        };

        $scope.$on(broadcastType.collapseExpandSidebar, function (e, target) {
            if (target.navigateSideBar) {
                currentRecursiveIndex = 0;
                //navigateToCurrentItem(null);
            }
        });

        function decorateNodes(areas, processes) {
            if (areas && areas.length) {
                for (var i = 0; i < areas.length; i++) {
                    areas[i].type = 0;
                }
            }
            if (processes && processes.length) {
                for (var i = 0; i < processes.length; i++) {
                    if (processes[i].processClassification == E.processClassificationTypes.Processes) {
                        processes[i].type = E.processRelatedItemType.Process;
                    } else {
                        processes[i].type = E.processRelatedItemType.ProcessInterconnected;
                    }
                    processes[i].id = processes[i].processNumber;
                }
            }
        }

        function getParentAreasRecursive(itemId, isArea) {
            return $http.get(handbookRequests.GetParentAreas, {
                params: {
                    processNumber: isArea ? null : itemId,
                    areaId: isArea ? itemId : null,
                    isArea: isArea
                }
            })
                .success(function (data, status, headers, config) {
                    if (data && data.length) {
                        var _parents = data;
                        decorateNodes(_parents, null);
                        if (!isArea) {
                            var process = {
                                id: itemId,
                                type: E.processRelatedItemType.Process,
                                parentAreaId: _parents[0].id
                            }
                            _parents = _parents.concat([process]);
                        }
                        navigateToCurrentItem($scope.processAreasList, _parents);
                    }
                    vm.isExpanded = false;
                },
                    function (data, status, headers, config) {
                        modelValue.items = [];
                    });
        }

        function navigateToCurrentItem(tempItems, recursives) {
            $timeout(function () {
                onChildrenLoaded(tempItems, recursives);
            }, 0);
        }

        function onChildrenLoaded(tempItems, recursives) {
            vm.parentList = recursives;
            vm.items = tempItems;
            if (currentRecursiveIndex < vm.parentList.length) {
                if (vm.items != null && vm.items.length) {
                    for (var i = 0; i < vm.items.length; i++) {
                        if (vm.items[i].id == vm.parentList[currentRecursiveIndex].id && vm.items[i].type == vm.parentList[currentRecursiveIndex].type) {
                            currentRecursiveIndex += 1;
                            indexOfChildren = i;
                            var node = angular.element('#treeProcesses #' + vm.items[indexOfChildren].id + '_' + vm.items[indexOfChildren].type);
                            if (!vm.items[indexOfChildren].expanded && vm.items[indexOfChildren].childCount > 0) {
                                node.trigger('click');
                            } else {
                                afterExpanded(vm.items[indexOfChildren].id, vm.items[indexOfChildren].type);
                            }
                            break;
                        }
                    }
                }
            }
        }

        function afterExpanded(nodeId, nodeType) {
            if (currentRecursiveIndex == vm.parentList.length) { // it's current area/process
                $timeout(function () {
                    var idSelected = angular.element("#treeProcesses #" + nodeId + '_' + (nodeType == E.processRelatedItemType.Process ? 'process' :
                        nodeType == E.processRelatedItemType.ProcessInterconnected ? 'processInterconnected' : 'area'));
                    $('.selected').removeClass('selected');
                    if (idSelected.length != 0) {
                        $(idSelected).addClass('selected');
                        $('.selected').focus();
                    }
                }, 0);
                currentRecursiveIndex = 0;
            } else if (currentRecursiveIndex != 0) {
                $timeout(function () {
                    vm.items = vm.items[indexOfChildren].items.map(function (element) {
                        if (element.entityId) {
                            let elementType = null;
                            if (element.processClassification == E.processClassificationTypes.ProcessInterconnected) {
                                elementType = E.processRelatedItemType.ProcessInterconnected;
                            } else {
                                elementType = E.processRelatedItemType.Process;
                            }
                            return {
                                id: element.processNumber,
                                type: elementType,
                                parentAreaId: element.processAreaId,
                                name: element.name,
                                expanded: true
                            }
                        }
                        else
                            return element;
                    });
                    onChildrenLoaded(vm.items, vm.parentList);
                }, 0);
            }
        }

        function setHighlight(event) {
            $('.selected').removeClass('selected');
            $(event.target).addClass('selected');
        }

        function getParentAreasProcessInterconnectedRecursive(itemId, isArea) {
            return $http.get(handbookRequests.GetParentAreasOfInterconnectedProcess, {
                params: {
                    processNumber: isArea ? null : itemId,
                    areaId: isArea ? itemId : null,
                    isArea: isArea
                }
            })
                .success(function (data, status, headers, config) {
                    if (data && data.length) {
                        var _parents = data;
                        decorateNodes(_parents, null);
                        if (!isArea) {
                            var process = {
                                id: itemId,
                                type: E.processRelatedItemType.ProcessInterconnected,
                                parentAreaId: _parents[0].id
                            }
                            _parents = _parents.concat([process]);
                        }
                        navigateToCurrentItem($scope.processAreasList, _parents);
                    }
                    vm.isExpanded = false;
                },
                    function (data, status, headers, config) {
                        modelValue.items = [];
                    });
        }

    };

})();

